import React from 'react';
import coverImage from './cover.jpeg';  // Import the image
import './App.css';

function RightSection() {
  return (
    <div className="right-image-section">
      <img
        src={coverImage}
        alt="Cover"
        className="cover-image"
      />

      <a 
        href="https://www.kobo.com/ww/en/ebook/the-ultimate-vocabulary-builder" 
        target="_blank" 
        rel="noopener noreferrer" 
        className="buy-now-button"
      >
        Buy Now
      </a>
    </div>
  );
}

export default RightSection;